// Mock data for SURFACE Labs landing page

export const testimonials = [
  {
    id: 1,
    name: "Anna Martinez",
    business: "Café Owner",
    content: "They built us a clean, fast website that actually brings in customers. No fluff, just results."
  },
  {
    id: 2,
    name: "Mike Thompson",
    business: "Auto Service",
    content: "Finally, a team that speaks plain English. Our website loads fast and looks professional."
  },
  {
    id: 3,
    name: "Sarah Chen",
    business: "Boutique Owner",
    content: "Best investment we made. Website went live in two weeks, and we're already seeing more bookings."
  },
  {
    id: 4,
    name: "David Rodriguez",
    business: "Contractor",
    content: "Straight to the point, no nonsense. They delivered exactly what we needed, when they said they would."
  }
];

export const workExamples = [
  {
    id: 1,
    name: "Ember Coffee Roasters",
    description: "Modern café website with online ordering",
    url: "https://example.com/ember-coffee",
    image: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800&h=600&fit=crop"
  },
  {
    id: 2,
    name: "Precision Auto Works",
    description: "Service booking system for auto repair shop",
    url: "https://example.com/precision-auto",
    image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=800&h=600&fit=crop"
  },
  {
    id: 3,
    name: "Zenith Wellness Studio",
    description: "Booking platform for yoga and wellness classes",
    url: "https://example.com/zenith-wellness",
    image: "https://images.unsplash.com/photo-1545205597-3d9d02c29597?w=800&h=600&fit=crop"
  },
  {
    id: 4,
    name: "Blueprint Construction",
    description: "Portfolio showcase for residential builder",
    url: "https://example.com/blueprint-construction",
    image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&h=600&fit=crop"
  },
  {
    id: 5,
    name: "Verde Plant Shop",
    description: "E-commerce site for local plant nursery",
    url: "https://example.com/verde-plants",
    image: "https://images.unsplash.com/photo-1466781783364-36c955e42a7f?w=800&h=600&fit=crop"
  },
  {
    id: 6,
    name: "Atlas Legal Services",
    description: "Professional site for local law practice",
    url: "https://example.com/atlas-legal",
    image: "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?w=800&h=600&fit=crop"
  }
];

export const trustPoints = [
  {
    id: 1,
    title: "10+ years combined experience",
    description: "We've been building websites since design trends were embarrassing."
  },
  {
    id: 2,
    title: "Websites for real businesses, not demos",
    description: "Every site we build is battle-tested in the real world."
  },
  {
    id: 3,
    title: "Clear communication, no bullshit",
    description: "We speak human, not marketing jargon. You'll always know what's happening."
  },
  {
    id: 4,
    title: "Built for speed, SEO, and conversions",
    description: "Fast loading, Google-friendly, and designed to turn visitors into customers."
  }
];

export const processSteps = [
  {
    id: 1,
    number: "01",
    title: "You email us what you need",
    description: "Tell us about your business and what you want your website to do. No forms, no calls, just email."
  },
  {
    id: 2,
    number: "02",
    title: "We design & build your website",
    description: "We handle everything — design, development, content. You review and give feedback."
  },
  {
    id: 3,
    number: "03",
    title: "You get a clean, working site — fast",
    description: "Launch in weeks, not months. Your site goes live, tested and ready to work."
  }
];